module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/3-a6e312dc3e58c7bba32bbb4e1e91f466.jpg";